import type { MessageKey } from "@expertloop/i18n";

/** Clé de libellé d'une référence : sa nature, jamais son contenu. */
export function refLabelKey(ref: string): MessageKey {
	if (ref.startsWith("message:")) return "adminChatDetail.report.ref.message";
	if (ref.startsWith("delivery:")) return "adminChatDetail.report.ref.delivery";
	if (ref === "order") return "adminChatDetail.report.ref.order";
	if (ref === "request") return "adminChatDetail.report.ref.request";
	if (ref.startsWith("event:")) return "adminChatDetail.report.ref.event";
	return "adminChatDetail.report.ref.unknown";
}

/** Fait défiler jusqu'à l'élément et le met brièvement en évidence. */
export function jumpTo(anchorId: string): void {
	const element = document.getElementById(anchorId);
	if (!element) return;
	element.scrollIntoView({ behavior: "smooth", block: "center" });
	element.classList.add("jump-highlight");
	window.setTimeout(() => element.classList.remove("jump-highlight"), 1800);
}

/**
 * Amène un élément au milieu de la colonne de conversation, sans rien faire défiler d'autre.
 *
 * `scrollIntoView` fait défiler tous les ancêtres, la page comprise : quand la colonne de droite
 * est déjà bien placée, il emportait la colonne de gauche avec lui. Ici, seule la colonne de
 * conversation défile, et seulement si elle le peut (elle est plus haute que l'écran) et que
 * l'élément n'est pas déjà entièrement visible.
 */
export function revealInConversation(element: HTMLElement): boolean {
	const container = element.closest<HTMLElement>(".mediation-conversation-aside");
	if (!container) return false;
	// Colonne entière à l'écran : rien à défiler
	if (container.scrollHeight <= container.clientHeight + 1) return false;
	const box = container.getBoundingClientRect();
	const target = element.getBoundingClientRect();
	if (target.top >= box.top && target.bottom <= box.bottom) return false;
	const offset = target.top - box.top + container.scrollTop;
	container.scrollTo({ top: Math.max(0, offset - (box.height - target.height) / 2), behavior: "smooth" });
	return true;
}
